import React from 'react';
import { PhoneInput } from 'react-international-phone';
import type { CountryIso2 } from 'react-international-phone';
import { AlertCircle } from 'lucide-react';
import 'react-international-phone/style.css';
import '../styles/components/phone-number-input.css';

export interface PhoneNumberInputProps {
  value: string;
  onChange: (_value: string) => void;
  defaultCountry?: CountryIso2;
  placeholder?: string;
  disabled?: boolean;
  error?: string;
  className?: string;
  inputId?: string;
  inputName?: string;
}

const PhoneNumberInput: React.FC<PhoneNumberInputProps> = ({
  value,
  onChange,
  defaultCountry = 'ae',
  placeholder = 'Enter mobile number',
  disabled,
  error,
  className,
  inputId,
  inputName,
}) => {
  return (
    <div className={`smarteco-phone-input-wrapper ${className || ''}`}>
      <PhoneInput
        defaultCountry={defaultCountry}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        inputProps={{
          id: inputId,
          name: inputName,
          autoComplete: 'tel',
          'aria-invalid': error ? true : undefined,
          'aria-describedby': error && inputId ? `${inputId}-error` : undefined,
        }}
        className={`smarteco-phone-input ${error ? 'has-error' : ''}`}
      />
      {error && (
        <p
          id={inputId ? `${inputId}-error` : undefined}
          className="text-red-500 text-sm mt-1 flex items-center gap-1"
        >
          <AlertCircle className="h-4 w-4" />
          {error}
        </p>
      )}
    </div>
  );
};

export default PhoneNumberInput;
